export const CONFIG = {
	protocol: 'https:',
	host: 'https://www.hormoonyoga.nl',
	fbAppID: '',
	twitterID: '@LizzyKnip',
};